export const vec = (x, y, z) => ({ x, y, z });
export const add = (a, b) => vec(a.x + b.x, a.y + b.y, a.z + b.z);
export const sub = (a, b) => vec(a.x - b.x, a.y - b.y, a.z - b.z);
export const scale = (a, k) => vec(a.x * k, a.y * k, a.z * k);
export const dot = (a, b) => a.x * b.x + a.y * b.y + a.z * b.z;
export const cross = (a, b) => vec(a.y * b.z - a.z * b.y, a.z * b.x - a.x * b.z, a.x * b.y - a.y * b.x);
export const length = (a) => Math.sqrt(dot(a, a));
export function normalise(a) {
    const len = length(a);
    if (len === 0)
        return vec(0, 0, 1);
    return scale(a, 1 / len);
}
/** Great-circle angle between two unit vectors, stable for small angles. */
export function angleBetween(a, b) {
    return Math.atan2(length(cross(a, b)), dot(a, b));
}
/** Spherical linear interpolation along the great circle from a to b. */
export function slerp(a, b, t) {
    const omega = angleBetween(a, b);
    if (omega < 1e-9)
        return normalise(a);
    const sinOmega = Math.sin(omega);
    return normalise(add(scale(a, Math.sin((1 - t) * omega) / sinOmega), scale(b, Math.sin(t * omega) / sinOmega)));
}
/** Rotate `v` about the unit axis `axis` by `angle` radians (Rodrigues). */
export function rotateAbout(v, axis, angle) {
    const c = Math.cos(angle);
    const s = Math.sin(angle);
    return add(add(scale(v, c), scale(cross(axis, v), s)), scale(axis, dot(axis, v) * (1 - c)));
}
//# sourceMappingURL=vec3.js.map